const logTypes = {
    "SUMMARY": "S",
    "PROGRAMMING": "P",
    "LAMBDA": "L"
}

export default logTypes;